/** Autoplays a muted looping video. Paused, or with reduced motion requested, it shows the still poster. */
if (!customElements.get('animated-image')) {
  customElements.define('animated-image', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.label = this.video.getAttribute('aria-label') || '';
      this.abortController = new AbortController();
      this.button.hidden = false;
      this.button.addEventListener('click', () => this.setPlaying(!this.playing), { signal: this.abortController.signal });
      this.setPlaying(!window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.video.pause();
    }

    setPlaying(playing) {
      this.playing = playing;
      if (playing) {
        this.video.play().catch(() => this.setPlaying(false));
      } else {
        this.video.pause();
        this.video.load(); /* back to the poster frame */
      }
      this.button.setAttribute('aria-pressed', String(playing));
      this.button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${this.label}`);
      this.button.querySelector('[data-play]').hidden = playing;
      this.button.querySelector('[data-pause]').hidden = !playing;
    }
  });
}
